/**
 * Get the current Eastern Time UTC offset in minutes.
 * Accounts for EST (-300) vs EDT (-240) automatically.
 */
function getEasternOffsetMinutes(): number {
    const now = new Date();
    const eastern = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit",
        hour12: false,
    }).formatToParts(now);

    const parts: Record<string, string> = {};
    eastern.forEach(p => { parts[p.type] = p.value; });

    const etDate = new Date(
        `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`
    );
    return Math.round((now.getTime() - etDate.getTime()) / 60000);
}

/** Convert a UTC Date to the equivalent wall-clock Date in Eastern Time. */
export function utcToEastern(utc: Date): Date {
    const offsetMs = getEasternOffsetMinutes() * 60000;
    return new Date(utc.getTime() - offsetMs);
}

/** Interpret a Date's wall-clock values as Eastern Time and convert to UTC. */
export function easternToUtc(eastern: Date): Date {
    const offsetMs = getEasternOffsetMinutes() * 60000;
    return new Date(eastern.getTime() + offsetMs);
}
